import { EnvironmentRequest, PasswordData } from 'vrlcm-gui-types';
import { Http } from 'vrlcm-gui-utils';
import {
  CREATE_LOCKER_REFERENCES_FROM_JSON_URL,
  GET_PASSWORD_ALIASES_URL,
  GET_PASSWORD_BY_VMID_URL,
  PREVALIDATE_JSON_SPEC_URL
} from '../../../constants/ApiUri';
import { AliasVmid } from '../../../types/Common';
import { ValidateSpecResponse } from '../../../types/workflows/steps/Environment';

export default class EnvironmentStepAPI {
  public static getPasswords = async (): Promise<AliasVmid[]> => {
    const passwords = await Http.get(GET_PASSWORD_ALIASES_URL);
    return passwords.data;
  };

  public static getPasswordByVmid = async (
    vmid: string
  ): Promise<PasswordData> => {
    const response = await Http.get(GET_PASSWORD_BY_VMID_URL(vmid));
    return response.data;
  };
  public static validateJsonSpec = async (
    spec?: EnvironmentRequest
  ): Promise<ValidateSpecResponse[]> => {
    const response = await Http.post(PREVALIDATE_JSON_SPEC_URL, spec);
    return response.data;
  };

  public static createLockerReferenceFromJsonSpec = async (
    spec?: EnvironmentRequest
  ): Promise<EnvironmentRequest> => {
    const response = await Http.post(
      CREATE_LOCKER_REFERENCES_FROM_JSON_URL,
      spec
    );
    return response.data;
  };
}
